<template>
    <search-select v-bind="$attrs" :options="options" :allow-empty="false" :searchable="false" label="name" track-by="num" :loading="loading" placeholder="Выберите валюту" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div class="ml-1">{{ scope.option.code }} {{ scope.option.symbol || scope.option.symbol.alt }}</div>
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div class="ml-1">{{ scope.option.code }} {{ scope.option.symbol || scope.option.symbol.alt }}</div>
            </div>
        </template>
    </search-select>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SearchSelect from '@/components/Select'

const state = new Vue.observable({
    loaded: false,
    loading: false,
    options: []
})

export const fetchOptions = async () => {
    if (state.loaded || state.loading) {
        return
    }

    try {
        const response = await axios.get('api/reference/currencies')

        state.options = response.data
    } finally {
        state.loaded = true
        state.loading = false
    }
}

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    computed: {
        options() {
            return state.options
        },

        loading() {
            return state.loading
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    },

    async created() {
        await fetchOptions()
    }
}
</script>
